import React, { useEffect, useState } from "react";
import { getDiseasePredictions, TFarmDataResponse } from "../../../services/farm.service";
import SpeedoMetersContainer from "./SpeedoMetersContainer";

type TProps = {
  plotId: string;
}

const DiseaseSpeedoMeters: React.FC<TProps> = (props) => {
  const { plotId } = props;

  const [diseasePredictions, setDiseasePredictions] = useState<TFarmDataResponse>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchDiseasePredictions();
  }, []);

  const fetchDiseasePredictions = async () => {
    try {
      setIsLoading(true);
      const response = await getDiseasePredictions(plotId);
      setDiseasePredictions(response);
    } catch(error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {
        !isLoading && <SpeedoMetersContainer 
          farmData={diseasePredictions}
          speedoMeterFor="disease"
          plotId={plotId}
        />
      }  
    </div>
  );
};

export default DiseaseSpeedoMeters;